<template>
  <div class="pic-metriche">
    <!-- Titolo -->
    <div class="metriche-title">
      METRICHE PIC
    </div>

    <!-- Separatore -->
    <div class="metriche-divider"></div>
    <b-row class="metric-grid">
      <b-col
          v-for="(column,index) in columns"
          :key="index"
          cols="12"
          :md="expanded ? 4 : 6"
          class="metric-column"
      >
          <div
              v-for="item in column"
              :key="item.key"
              class="metrica-row"
          >
              <span class="metrica-label">
                  {{ item.label }}
              </span>
              <span class="metrica-value">
                  {{ formatValue(item) }}
              </span>
          </div>
      </b-col>
    </b-row>
  </div>
</template>


<script>
export default {
  name: "PICMetriche",

  props: {
    metriche: {
      type: Object,
      default: () => ({})
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },


  computed: {

    items() {
      return [
        {
          key: "art51c3",
          label: "Fringe benefit",
          value: this.metriche.art51c3
        },
        {
          key: "art100",
          label: "Tempo libero",
          value: this.metriche.art100
        },
        {
          key: "conv_locali",
          label: "Convenzioni Locali",
          value: this.metriche.conv_locali
        },
        {
          key: "rimborsi",
          label: "Rimborsi",
          value: this.metriche.rimborsi
        },
        {
          key: "previdenza",
          label: "Previdenza",
          value: this.metriche.previdenza
        },
        {
          key: "sanita",
          label: "Sanità",
          value: this.metriche.sanita
        },
        {
          key: "bonus_carburante",
          label: "Bonus Carburante",
          value: this.metriche.bonus_carburante
        },
        {
          key: "piattapasto",
          label: "Piattapasto",
          value: this.metriche.piattapasto
        },
        {
          key: "tot_storni_scad",
          label: "Ristorno crediti scaduti",
          value: this.metriche.tot_storni_scad
        },
        {
          key: "tot_storni_contr",
          label: "Ristorno crediti per contratto scaduto",
          value: this.metriche.tot_storni_contr
        },
        {
          key: "acq_in_attesa",
          label: "Pratiche in attesa",
          value: this.metriche.acq_in_attesa,
        }
      ];
    },

    columns() {

      const colonne = this.expanded ? 3 : 2;

      const result = Array.from({ length: colonne }, () => []);

      this.items.forEach((item, index) => {
        result[index % colonne].push(item);
      });

      return result;
    }
  },

  methods: {

    // Formatta l'importo in euro con separatore delle migliaia e due decimali
    formatEuro(value) {

      const valore = Number(value || 0);

     if (valore === 0) {
        return "—";
      }

      const numero = new Intl.NumberFormat(
        "it-IT",
        {
          useGrouping: true,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      ).format(valore);

      return `€ ${numero}`;
    },

    formatValue(item) {

      if (item.numeric) {
        return item.value ? item.value : "—";
      }

      return this.formatEuro(item.value);
    }
  }
};
</script>


<style scoped>

.pic-metriche {
  width: 100%;
  margin-top: 8px;
}

/* Titolo */
.metriche-title {
  font-size: 16px;
  font-weight: 600;
  color: #373F66;
  margin-bottom: 4px;
}

/* linea separazione */
.metriche-divider {
  height: 2px;
  background: #373F66;
  margin-bottom: 10px;
}

/* spazio tra colonne */
.metric-grid {
  row-gap: 8px;
  margin-left: -4px;
  margin-right: -4px;
}

/* singola card metrica */
.metrica-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 10px 14px;
  min-height: 50px;
  margin-bottom: 8px;
  transition: box-shadow .2s ease;
}

.metric-column {
  padding-left: 4px;
  padding-right: 4px;
}

.metrica-row:hover {
  box-shadow: 0 2px 6px rgba(0,0,0,.08);
}

.metrica-label {
  color: #555;
  font-size: 15px;
  font-weight: 500;
}

.metrica-value {
  font-weight: 600;
  color: #373F66;
  font-size: 16px;
  text-align: right;
}

@media (max-width:768px) {

  .metrica-row {
    padding: 10px 12px;
     min-height: 48px;
  }

  .metrica-label,
  .metrica-value {
    font-size: 14px;
  }
}

</style>